import ApiService from './ApiService';

class ElasticSearchApi extends ApiService {
    search(payload: any) {
        return this.post('elastic-search', payload);
    }
}

const elasticSearchApi = new ElasticSearchApi();
export default elasticSearchApi;
